import {makeStyles} from '@material-ui/core/styles'
import AccountAvatar from '../accountDetail/AccountAvatar'
import {Text} from '../../../1elements'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'

const ContactCard = ({className, data, clickHandler}) => {
    const classes = useStyles()
    const {first_name, last_name, phone_number, email_address, contact_id, job_title, avatar, isActive} = data
    const fullName = `${first_name} ${last_name}`

    return (
        <div className={`${classes.root} ${className}`} onClick={()=>clickHandler(contact_id, job_title)}>
            <AccountAvatar className={classes.avatar} accountName={fullName} avatar={avatar} online={isActive} />
            <div className={classes.contactDataDiv}>
                <Text type={'h3'} className={classes.contactName}>{fullName}</Text>

                <div className={classes.contactRow}>
                    <PhoneIcon className={classes.icon} style={{fontSize: 18}} /><Text>{phone_number}</Text>
                </div>
                <div className={classes.contactRow}>
                    <EmailIcon className={classes.icon} style={{fontSize: 18}} /><Text>{email_address}</Text>
                </div>
            </div>
        </div>
    )
}

export default ContactCard

const useStyles = makeStyles((theme)=>({
    root: {
        display: 'flex',
        alignItems: 'center',
        margin: 5,
        padding: 10,
        cursor: 'pointer',
    },
    avatar: {
        width: 54,
        height: 54,
        '& *': {
            fontSize: 20
        }
    },
    contactName: {
        color: theme.palette.primary.accent
    },
    contactRow: {
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        marginRight: 10,
        fontSize: 18,
        color: theme.palette.primary.main
    },
    contactDataDiv: {
        marginLeft: 15
    }
}))
